import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CCOList } from "~/components/cco-list";
import Heading from "~/components/ui/heading";

function CCOsPage() {
  return (
    <div className="container mx-auto flex flex-col gap-6 px-4 py-8">
      <Heading isH1 headline="All Coaching Organizations" />
      <div className="mx-auto w-full max-w-prose">
        <CCOList />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_public/ccos/")({
  head: () => ({
    title: "List of All Coaching Organizations",
    meta: [
      {
        name: "description",
        content:
          "A complete list of coaching organizations partnered with us, grouped by category.",
      },
    ],
  }),
  component: CCOsPage,
});
